export const PICKABLE_TRANSPARENT_OPACITY = 0.000000000001;
